import { createSlice, createAsyncThunk, isAnyOf } from '@reduxjs/toolkit';
import { InspectionResults } from 'Service/api/inspectionresults-service';
import { showToast } from 'Core/redux/toast/slice';
import { closeModal, showModal } from 'Core/redux/main/slice';
import { redux } from 'Core/redux';
import { saveAs } from 'Core/utils';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import { selectStatusLoading } from '../../../core/redux/status/selectors';
const { INSPECTIONRESULTS_ADD_EDIT } = MODAL_TYPES;

export const STORE_KEY = 'inspectionresults';
export const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
  filters: {
    searchText: '',
    status: {
      value: 'In Production',
      label: 'In Production',
    },
    // startDate: null,
    // endDate: null,
  },
  inspectionResultsDataFilters: {
    fromDate: null,
    toDate: null,
  },
  inspectionResultsQCDataFilters: {
    fromDate: null,
    toDate: null,
  },
  inspectionResultsDataSortKey: {
    value: 'categoryName',
    label: 'Sort By Category',
  },
  filterVisible: false,
  tileView: true,
  selectedInspectionResults: null,
  deepLink: null,
  editModalVisible: false,
  approvalData: null,
  // Pagination state for QC Results
  qcResultsPagination: {
    currentPage: 1,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
  },
  // Pagination state for AQL Results
  aqlResultsPagination: {
    currentPage: 1,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
  },
};

export const fetchInspectionResults = createAsyncThunk(
  'inspectionresults/fetchInspectionResults',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await InspectionResults.getAllInspectionResults(filters);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to load Inspection Plans');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to load Inspection Plans');
    }
  },
);

export const approveRejectInspectionResults = createAsyncThunk(
  'inspectionresults/approveRejectInspectionResults',
  async (reqBody, { rejectWithValue }) => {
    try {
      const response = await InspectionResults.approveRejectInspectionResults(reqBody);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to act on Quality');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to act on Quality');
    }
  },
);

export const addInspectionResults = createAsyncThunk(
  'inspectionresults/addInspectionResults',
  async (inspectionResultsPayload, { rejectWithValue }) => {
    try {
      const response = await InspectionResults.createInspectionResults(inspectionResultsPayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to add Inspection Plans');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to add Inspection Plans');
    }
  },
);

export const editInspectionResults = createAsyncThunk(
  'inspectionresults/editInspectionResults',
  async (inspectionResultsPayload, { rejectWithValue }) => {
    try {
      const response = await InspectionResults.createInspectionResults(inspectionResultsPayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to update inspectionresults',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update inspectionresults');
    }
  },
);

export const extendInspectionResults = createAsyncThunk(
  'inspectionresults/extendInspectionResults',
  async (inspectionResultsPayload, { rejectWithValue }) => {
    try {
      const response = await InspectionResults.extendInspectionResults(inspectionResultsPayload);
      if (response.status === 200) {
        return response.response;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to update inspectionresults',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update inspectionresults');
    }
  },
);

export const downloadinspectionResultss = createAsyncThunk(
  'inspectionresults/downloadInspectionResultss',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await InspectionResults.downloadInspectionResults(filters);
      const blob = response;
      saveAs(blob, `InspectionResultss.xlsx`);
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to download Inspection Plans');
    }
  },
);

export const deleteInspectionResultss = createAsyncThunk(
  'inspectionresults/deleteInspectionResults',
  async (inspectionResultssId, { rejectWithValue }) => {
    try {
      const response = await InspectionResults.deleteInspectionResultss(inspectionResultssId);
      if (response.status === 200) {
        return inspectionResultssId;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to delete inspectionresults',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to delete inspectionresults');
    }
  },
);

export const fetchInspectionResultssWithFilters = () => (dispatch, getState) => {
  const filters = getState().inspectionresults.filters;
  dispatch(
    fetchInspectionResults({
      // searchText: filters.searchText,
      // customer: filters?.customer?.value,
      status: filters?.status?.value,
      // inspectionResultsDate: filters?.shipDate,
    }),
  );
};

export const downloadInspectionResultssWithFilters = () => (dispatch, getState) => {
  const filters = getState().inspectionresults.filters;
  dispatch(
    downloadinspectionResultss({
      searchText: filters.searchText,
      customer: filters?.customer?.value,
      status: filters?.status?.value,
      inspectionResultsDate: filters?.shipDate,
    }),
  );
};

export const fetchInspectionResultsData = createAsyncThunk(
  'inspectionresults/fetchInspectionResultsData',
  async ({ inspectionresults, pageNumber = 1, pageSize = 10 }, { rejectWithValue }) => {
    try {
      console.log('fetchInspectionResultsData - inspectionresults object:', inspectionresults);
      
      // Handle different possible ID property names
      const partId = inspectionresults.id || inspectionresults.partId || inspectionresults.inspectionResultsId;
      
      console.log('fetchInspectionResultsData - extracted partId:', partId);
      
      if (!partId) {
        console.error('Part ID not found in inspectionresults object:', inspectionresults);
        return rejectWithValue('Part ID is required but not found in the selected part');
      }
      
      console.log('fetchInspectionResultsData - calling API with partId:', partId, 'pageNumber:', pageNumber, 'pageSize:', pageSize);
      
      const response = await InspectionResults.getInspectionResultsById(partId, pageNumber, pageSize);
      
      console.log('fetchInspectionResultsData - API response:', response);
      
      if (response.status === 200) {
        return { 
          ...response.response, 
          pagination: { pageNumber, pageSize } 
        };
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to load inspection results data');
      }
    } catch (error) {
      console.error('fetchInspectionResultsData - error:', error);
      return rejectWithValue(error.message || 'Failed to load inspection results data');
    }
  },
);

export const quarantineInspectionResults = createAsyncThunk(
  'inspectionresults/quarantineinv',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await InspectionResults.Quarantine(payload);
      if (response.status === 200) {
        return payload;
      } else {
        return rejectWithValue(response.errorMessage?.message || 'Failed to quarantine');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to quarantine');
    }
  },
);

export const releaseInspectionResults = createAsyncThunk(
  'inspectionresults/releaseinv',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await InspectionResults.Release(payload);
      if (response.status === 200) {
        return payload;
      } else {
        return rejectWithValue(
          response.errorMessage?.message || 'Failed to release inspectionresults',
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to release inspectionresults');
    }
  },
);

export const { reducer, actions, caseReducers } = createSlice({
  name: 'inspectionResults',
  initialState: INITIAL_STATE,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    resetFilters: state => {
      state.filters = INITIAL_STATE.filters;
    },
    setSelectedPart: (state, action) => {
      state.selectedInspectionResults = action.payload;
    },
    setDeepLink: (state, action) => {
      state.deepLink = action.payload;
    },
    clearDeepLink: state => {
      state.deepLink = null;
    },
    setFilterVisible: (state, action) => {
      state.filterVisible = action.payload;
    },
    setSearchText: (state, action) => {
      state.filters.searchText = action.payload;
    },
    setInspectionResultsDataFilters: (state, action) => {
      state.inspectionResultsDataFilters.fromDate = action.payload.fromDate;
      state.inspectionResultsDataFilters.toDate = action.payload.toDate;
    },
    setInspectionResultsQCDataFilters: (state, action) => {
      state.inspectionResultsQCDataFilters.fromDate = action.payload.fromDate;
      state.inspectionResultsQCDataFilters.toDate = action.payload.toDate;
    },
    setInspectionResultsSortKey: (state, action) => {
      state.inspectionResultsDataSortKey = action.payload;
    },
    setCustomer: (state, action) => {
      state.filters.customer = action.payload;
    },
    setStatus: (state, action) => {
      state.filters.status = action.payload;
    },
    setStartDate: (state, action) => {
      state.filters.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.filters.endDate = action.payload;
    },
    setTileView: (state, action) => {
      state.tileView = action.payload; // Add reducer to update tileView
    },
    updateInspectionResultsData: (state, action) => {
      state.inspectionResultsData = action.payload;
      console.log(action.payload);
    },
    setQcResultsPagination: (state, action) => {
      state.qcResultsPagination = { ...state.qcResultsPagination, ...action.payload };
    },
    resetQcResultsPagination: (state) => {
      state.qcResultsPagination = INITIAL_STATE.qcResultsPagination;
    },
    setAqlResultsPagination: (state, action) => {
      state.aqlResultsPagination = { ...state.aqlResultsPagination, ...action.payload };
    },
    resetAqlResultsPagination: (state) => {
      state.aqlResultsPagination = INITIAL_STATE.aqlResultsPagination;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchInspectionResults.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInspectionResults.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchInspectionResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addInspectionResults.fulfilled, (state, action) => {
        const newInspectionResults = {
          ...action.payload,
          isNewlyCreated: true,
        };
        state.data = [newInspectionResults, ...state.data];
      })
      .addCase(addInspectionResults.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(extendInspectionResults.fulfilled, (state, action) => {
        const newInspectionResults = {
          ...action.payload,
          isNewlyCreated: true,
        };
        state.data = [newInspectionResults, ...state.data];
      })
      .addCase(extendInspectionResults.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(editInspectionResults.fulfilled, (state, action) => {
        const index = state.data.findIndex(s => s.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(editInspectionResults.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(fetchInspectionResultsData.pending, state => {
        state.inspectionResultsLoading = true;
        state.inspectionResultsError = null;
      })
      .addCase(fetchInspectionResultsData.fulfilled, (state, action) => {
        state.inspectionResultsLoading = false;
        state.inspectionResultsData = action.payload;
        
        // Update QC pagination info if available - with null checks
        if (action.payload && action.payload.totalQCResultsCount !== undefined) {
          state.qcResultsPagination.totalCount = action.payload.totalQCResultsCount;
          state.qcResultsPagination.totalPages = Math.ceil(action.payload.totalQCResultsCount / state.qcResultsPagination.pageSize);
        } else {
          // Fallback: calculate total count from qcResults length if totalQCResultsCount is not available
          if (action.payload && action.payload.qcResults && Array.isArray(action.payload.qcResults)) {
            state.qcResultsPagination.totalCount = action.payload.qcResults.length;
            state.qcResultsPagination.totalPages = Math.ceil(action.payload.qcResults.length / state.qcResultsPagination.pageSize);
          }
        }

        // Update AQL pagination info if available - with null checks
        if (action.payload && action.payload.totalAQLResultsCount !== undefined) {
          state.aqlResultsPagination.totalCount = action.payload.totalAQLResultsCount;
          state.aqlResultsPagination.totalPages = Math.ceil(action.payload.totalAQLResultsCount / state.aqlResultsPagination.pageSize);
        } else {
          // Fallback: calculate total count from aqlResults length if totalAQLResultsCount is not available
          if (action.payload && action.payload.aqlResults && Array.isArray(action.payload.aqlResults)) {
            state.aqlResultsPagination.totalCount = action.payload.aqlResults.length;
            state.aqlResultsPagination.totalPages = Math.ceil(action.payload.aqlResults.length / state.aqlResultsPagination.pageSize);
          }
        }

        if (action.payload && action.payload.pagination) {
          state.qcResultsPagination.currentPage = action.payload.pagination.pageNumber;
          state.qcResultsPagination.pageSize = action.payload.pagination.pageSize;
          state.aqlResultsPagination.currentPage = action.payload.pagination.pageNumber;
          state.aqlResultsPagination.pageSize = action.payload.pagination.pageSize;
        }
      })
      .addCase(fetchInspectionResultsData.rejected, (state, action) => {
        state.inspectionResultsLoading = false;
        state.inspectionResultsError = action.payload;
      })
      .addCase(approveRejectInspectionResults.pending, state => {
        state.approvalLoading = true;
        state.approvalError = null;
      })
      .addCase(approveRejectInspectionResults.fulfilled, (state, action) => {
        state.approvalLoading = false;
        state.approvalData = action.payload;
      })
      .addCase(approveRejectInspectionResults.rejected, (state, action) => {
        state.approvalLoading = false;
        state.approvalError = action.payload;
      })
      .addCase(deleteInspectionResultss.fulfilled, (state, action) => {
        const newData = state.data.filter(s => s.id !== action.payload);
        state.data = newData;
      });
  },
});

export const updateInspectionResultsDataWithComment =
  (requestId, comments, modalId) => (dispatch, getState) => {
    const inspectionResultsData = getState().inspectionresults.inspectionResultsData;
    const updatedData = inspectionResultsData.map(qaObj => {
      return qaObj.requestId == requestId
        ? {
            ...qaObj,
            comments: comments,
          }
        : qaObj;
    });
    dispatch(actions.updateInspectionResultsData(updatedData));
    //dispatch(updateModalData(modalId,updatedData));
  };

redux.listener.startListening({
  matcher: isAnyOf(
    addInspectionResults.rejected,
    editInspectionResults.rejected,
    fetchInspectionResultsData.rejected,
    quarantineInspectionResults.rejected,
    releaseInspectionResults.rejected,
    extendInspectionResults.rejected,
    approveRejectInspectionResults.rejected,
  ),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: action.payload,
        type: 'danger',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(
    addInspectionResults.fulfilled,
    extendInspectionResults.fulfilled,
    editInspectionResults.fulfilled,
  ),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(closeModal(INSPECTIONRESULTS_ADD_EDIT));
    listenerApi.dispatch(
      showToast({
        message: 'InspectionResults saved successfully',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(quarantineInspectionResults.fulfilled, releaseInspectionResults.fulfilled),
  effect: (action, listenerApi) => {
    selectStatusLoading(false);
    listenerApi.dispatch(
      showToast({
        message: 'InspectionResults saved successfully',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(
    addInspectionResults.fulfilled,
    extendInspectionResults.fulfilled,
    editInspectionResults.fulfilled,
  ),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(closeModal(INSPECTIONRESULTS_ADD_EDIT));
    listenerApi.dispatch(
      showToast({
        message: 'InspectionResults saved successfully',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(fetchInspectionResultsData.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(showModal(INSPECTIONRESULTS_ADD_EDIT, action.payload));
  },
});

redux.listener.startListening({
  matcher: isAnyOf(approveRejectInspectionResults.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: 'Action successful',
        type: 'success',
      }),
    );
  },
});

redux.listener.startListening({
  matcher: isAnyOf(deleteInspectionResultss.fulfilled),
  effect: (action, listenerApi) => {
    listenerApi.dispatch(
      showToast({
        message: 'InspectionResults deleted successfully',
        type: 'success',
      }),
    );
  },
});

redux.injectReducer(STORE_KEY, reducer);
